import { render } from "./EditRecord.vue?vue&type=template&id=297878cc"
import script from "./EditRecord.vue?vue&type=script&lang=js"
export * from "./EditRecord.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/EditRecord.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "297878cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('297878cc', __exports__)) {
    console.log('reload')
    api.reload('297878cc', __exports__)
  }
  
  module.hot.accept("./EditRecord.vue?vue&type=template&id=297878cc", () => {
    console.log('re-render')
    api.rerender('297878cc', render)
  })

}


export default __exports__